import type { WarehouseRes, TWarehousesForClientOfficeRes } from 'api/swagger';

// Overload signatures
export function findWarehouseById(id: number | null, warehouses?: WarehouseRes[]): WarehouseRes | undefined;
export function findWarehouseById(
  id: number | null,
  warehouses?: TWarehousesForClientOfficeRes[],
): TWarehousesForClientOfficeRes | undefined;

// Implementation
export function findWarehouseById(
  id: number | null,
  warehouses?: WarehouseRes[] | TWarehousesForClientOfficeRes[],
): WarehouseRes | TWarehousesForClientOfficeRes | undefined {
  if (!warehouses || !id) return undefined;

  return warehouses.find((warehouse) => warehouse.id === id);
}
